
import React from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import BlogList from "@/components/blog/BlogList";
import Footer from "@/components/home/Footer";

const Blog = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Blog | Hivetivity - Youth Program Management Software</title>
        <meta 
          name="description" 
          content="Explore our latest articles on youth program management, dance studio tips, and educational best practices." 
        />
        <meta 
          name="keywords" 
          content="youth program blog, dance studio management, education blog, program management tips" 
        />
        <link rel="canonical" href="https://hivetivity.com/blog" />
      </Helmet>
      
      <TopNavbar />
      
      <div className="pt-16">
        <div className="container mx-auto px-4 py-12">
          <h1 className="text-3xl md:text-4xl font-bold text-secondary mb-2">Hivetivity Blog</h1>
          <p className="text-lg text-secondary/80 mb-8">
            Insights and tips for running successful youth programs
          </p>
          <BlogList />
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Blog;
